import $ from 'jquery';
import tips from './tips';
import api from './api';
import {
  initRecord,
  showTips,
  handleRewardPopup,
  handleQuanPopup,
} from './popup'
import {
  state,
  getBindInfo,
  initSignState,
  checkLogin,
  checkLoginAndBind,
  initExchangeState,
  initLotteryState,
  lotteryAnimate,
  initFirstStoreState,
  jumpStorePage,
  gotoLogin,
  roleInfoInit,
  doAnimate,
  checkIsActivityEnd
} from './main'


export const initBindEvent = () => {
  $('.j-jump-store').on('click', function (event) {
    if (state.isActivityEnd) {
      showTips(tips.get('timeEndGoStore'))
      return
    }
    jumpStorePage()
  })

  $('.j-sidebar-close').on('mouseenter', function (event) {
    $('.j-sidebar-wrap').addClass('show')
  })

  $('.j-sidebar-wrap').on('mouseleave', function (event) {
    $('.j-sidebar-wrap').removeClass('show')
  })

  $('.j-record').on('click', function (event) {
    if (checkLogin()) {
      initRecord()
    }
  })

  $('.j-zhanli-lingqu').on('click', async function (event) {
    if (state.ce) {
      return
    }
    checkLoginAndBind(async () => {
      const res = await api.getZhanliReward(getBindInfo())
      if (res && +res.code === 1) {
        state.ce = 1
        $('.j-zhanli-lingqu').addClass('get')
      } else {
        showTips(tips.get(res.code));
      }
    })
  })

  $('.j-book').on('click', function (event) {
    if (checkIsActivityEnd()) {
      return
    }
    checkLoginAndBind(() => {
      doAnimate()
    })
  })

  $('.j-rule').on('click', async function (event) {
    $('.j-popup-rule').fadeIn()
  })

  $('.j-sign-reward-item-btn').on('click', async function (event) {

    if (checkIsActivityEnd()) {
      return
    }

    if ($(this).hasClass('get')) {
      return;
    }

    if ($(this).hasClass('canget')) {
      checkLoginAndBind(async () => {
        let id = $(this).attr('data-id')
        let pid = $(this).attr('data-pid')
        let bindInfo = getBindInfo()
        let getRewardInfo = Object.assign(bindInfo, { id })
        let res = await api.getSignReward(getRewardInfo)
        if (res && +res.code === 1) {
          state.signInGifts = res.data.signInGifts.map(Number)
          handleRewardPopup(pid)
          initSignState()
        } else {
          showTips(tips.get(res.code));
        }
      })
    }
  })

  $('.j-award-item-btn').on('click', async function (event) {
    if (checkIsActivityEnd()) {
      return
    }

    if ($(this).hasClass('get')) {
      return
    }
    checkLoginAndBind(async () => {
      let id = $(this).attr('data-id')
      let pid = $(this).attr('data-pid')
      let getRewardInfo = Object.assign(getBindInfo(), { id })
      const res = await api.exchange(getRewardInfo)
      if (res && +res.code === 1) {
        state.part3 = res.data.part3.map(Number)
        initExchangeState()
        handleRewardPopup(pid)
      } else {
        showTips(tips.get(res.code));
      }
    })
  })

  $('.j-flush-btn').on('click', async function (event) {
    if (checkIsActivityEnd()) {
      return
    }
    const res = await api.chanceFlash()
    if (res && +res.code === 1) {
      state.pickTimes = +res.data.pickTimes
      state.total = +res.data.usedTimes
      initLotteryState()
      initExchangeState()
      return
    }
    showTips(tips.get(res.code));
  })

  $('.j-lottery-btn').on('click', function (event) {
    if (checkIsActivityEnd()) {
      return
    }
    checkLoginAndBind(() => {
      // 沒抽獎次數
      if (state.pickTimes <= 0) {
        showTips(tips.get('noChance'));
        return
      }
      //剩余抽奖券大于0，但已经抽空奖池
      if (state.lotteryGetIndex.length === 15) {
        showTips(tips.get('allHasGet'));
        return
      }
      lotteryAnimate()
    })
  })

  $('.j-award-btn').on('click', async function (event) {
    if (checkIsActivityEnd()) {
      return
    }
    if (checkLogin() && !state.isPicked) {
      const res = await api.getActivityQuan()
      if (res && +res.code === 1) {
        state.isPicked = 1
        initFirstStoreState()
        handleQuanPopup('300')
      } else {
        showTips(tips.get(res.code));
      }
    }
  });

  $('.j-popup-tip-btn').on('click', function (event) {
    if ($(this).hasClass('jump')) {
      jumpStorePage()
      return
    }

    if ($(this).hasClass('login')) {
      gotoLogin(0)
      return
    }
  });

  $('.j-change-character').on('click', function (event) {
    $('.j-server').html('請選擇伺服器');
    $('.j-server').attr('data-id', '');
    $('.j-server').attr('data-sid', '');
    $('.j-character').html('請選擇角色');
    $('.j-character').attr('data-id', '');
    $('.j-popup-juese').fadeIn();
  });

  $('.j-bind,.j-change-bind').on('click', function (event) {
    if (checkLogin()) {
      $('.j-popup-juese').fadeIn();
    }

  });

  $('.j-popup-close').on('click', function (event) {
    $('.j-popup').fadeOut();
  });

  $('.j-server-content').on('click', async function (event) {
    $('.j-character-list').hide()
    if ($(".j-server-list").css("display") == "block") {
      $(".j-server-list").hide();
    } else {
      if (state.serverList.length) {
        $('.j-server-list').show();
      } else {
        const res = await api.getServer()
        let html = "";
        if (res && +res.code === 1) {
          res.data.forEach(serve => {
            const filterIdArr = ['107001', '107002', '107003', '107004', '107005', '107006', '107007', '107008', '107009', '107010'];
            if (!filterIdArr.includes(serve.id.toString())) {
              html += `<li class="j-server-list-item server-list-item" data-id=${serve.id} data-sid=${serve.sid}>${serve.sname}</li>`
            }
          })
          $(".j-server-list").html(html);
          $(".j-server-list").show();
          state.serverList = res.data;
        }
      }
    }
  });

  $('.j-server-list').on('click', '.j-server-list-item', function (event) {
    let serverSid = $(this).attr('data-sid');
    let serverId = $(this).attr('data-id');
    let serverName = $(this).html();
    $('.j-server').attr('data-sid', serverSid);
    $('.j-server').attr('data-id', serverId);
    $('.j-server').html(serverName);
    $('.j-server-list').hide();
    $('.j-character').html('請選擇角色');
    $('.j-character').attr('data-id', '');
  });

  $('.j-character-content').on('click', async function (event) {
    if ($('.j-character-list').css('display') == 'block') {
      $('.j-character-list').hide();
    } else {
      let serverId = $('.j-server').attr('data-sid');
      if (!serverId) {
        alert('請選擇伺服器');
        return;
      }
      const res = await api.getCharacter(serverId)
      let html = '';
      if (res && +res.code === 1) {
        for (let i = 0; i < res.data.length; i++) {
          html += `<li class="j-character-list-item character-list-item" data-id=${res.data[i].roleID}>${res.data[i].roleName}</li>`;
        }
      } else {
        html += `<li class="j-character-list-item character-list-item">暫無角色</li>`;
      }
      $('.j-character-list').html(html).show();
    }
  });

  $('.j-character-list').on(
    'click',
    '.character-list-item',
    function (event) {
      let characterId = $(this).attr('data-id');
      let characterName = $(this).html();
      $('.j-character').attr('data-id', characterId);
      $('.j-character').html(characterName);
      $('.j-character-list').hide();
    }
  );

  $('.j-popup-juese-confirm').on('click', function (event) {
    let sid = $('.j-server').attr('data-sid');
    let rid = $('.j-character').attr('data-id');
    let sname = $('.j-server').html();
    let rname = $('.j-character').html();

    if (!sid) {
      alert('請選擇伺服器');
      return
    }

    if (!rid) {
      alert('請選擇角色');
      return
    }

    let charInfo = { sid, rid, sname, rname };
    state.isBind = true;
    state.roleInfo = Object.assign(charInfo, {})
    roleInfoInit();
    $('.j-popup-juese').fadeOut();
  });

  $('.j-logout-btn').on('click', function () {
    api.logout().then(res => {
      window.location.reload();
    });
  });

  $('.j-login-btn').on('click', function () {
    gotoLogin(0);
  });

  $('.j-scroll').on('click', function () {
    let scrollEleSelector = $(this).attr('data-scroll')
    $('html, body').animate({
      scrollTop: $(scrollEleSelector).offset().top + 150
    }, 500);
  })
}